import GameCarousel from './GameCarousel';

const slotGames = [
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/06bd8636733256a7bf4ebd15fd4fe66d.png', alt: 'BGaming Wild Tiger' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/dcebfbf0ab720ea473b8931482415ad2.png', alt: 'Hacksaw Stack Em' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/200ceb3a7a2705c15410c7e6069a3f0a.png', alt: 'BGaming Beer Bonanza' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/7580faea4ffc8c4218ca29533e1731cc.png', alt: 'Amigo The Frozen Crown' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/35e74552e2e94f01ea6fbe0d2b2d00a3.png', alt: 'BGaming Hottest 666' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/4ec5ca32ca9eba4a961326621d2218b9.png', alt: 'Hacksaw 2 Wild 2 Die' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/dca078343c778247290dc71829e9adbb.png', alt: 'Hacksaw Feel The Beat' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/d2a42f2e8b5fcc170f2f8246414834c9.png', alt: 'BGaming Wild Heart' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/25a9b3a841513606691f54cd2ca52273.png', alt: 'Hacksaw Chaos Crew II' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/e5970e94abd6658167dae03e68c4831f.png', alt: 'BGaming Tramp Day' },
];

const checkItems = [
  'User-Friendly Layout',
  'Endless Choice of Games',
  'BIG Progressive Jackpots',
  'Friendly Customer Care',
];

export default function SlotsSection() {
  return (
    <section className="bg-[#0d0d0d] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12">
          {/* Left image */}
          <div className="flex-1 w-full flex justify-center">
            <img
              src="https://playdash.me/assets/images/home-slots.png"
              alt="Online Slots Games at PNGGO"
              className="mx-auto h-auto w-auto max-h-[190px] max-w-[260px] object-contain sm:max-h-[260px] sm:max-w-md md:max-h-none md:max-w-md"
            />
          </div>

          {/* Right content */}
          <div className="flex-1 w-full">
            <p className="text-[#B80E28] text-xs font-semibold tracking-widest uppercase mb-2">
              YOUR ONE STOP SLOT GAME PLATFORM IN PAPUA NEW GUINEA
            </p>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-5">
              Online Slots Papua New Guinea
            </h2>
            <ul className="flex flex-col gap-3 mb-5">
              {checkItems.map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white/80 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center bg-[#B80E28]/20 rounded-full flex-shrink-0">
                    <i className="fas fa-check text-[#B80E28] text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <p className="text-white/60 text-sm leading-7 mb-6">
              PNGGO is one of the most popular sites for <strong className="text-white">Papua New Guinea Slot Online</strong>. If you&apos;re in Papua New Guinea and want to play online slot games from the best place, look no further than PNGGO. We proudly offer various slot games from the best software providers, such as BNG, WF Gaming, Meta Gaming, SCR888, JILI, VPower, 918Kaya, MEGAH5, UU Slots, JDB, and Live22.
            </p>
            <div className="mb-6 px-5">
              <GameCarousel images={slotGames} />
            </div>
            <a
              href="https://pnggo.bet/RFLANDINGPAGEPNG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#B80E28] text-white font-semibold px-7 py-3 rounded-full hover:bg-[#9a0b21] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              PLAY NOW <i className="fas fa-chevron-right text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
